<section class="bem-vindo">
  <img src="assets/images/verify-safe-1.png" width="200" alt="seguranca">

  <div class="bem-vindo__title">Bem-vindo à <br><span>Assinatura Eletrônica</span><br> Omni</div>

  <p>A partir de agora vamos iniciar o <strong>Procedimento de Segurança</strong> para a Assinatura Eletrônica do seu contrato com a Omni.</p>
</section>
